<ag-modal-base>
  <div class="typography-body-small flex flex-col gap-2 text-text-common-base">
    @if (action === "accept planning items") {
      The following will happen when confirmed:
      <ul class="flex list-disc flex-col gap-1 pl-5">
        @if (addLineItemCount > 0) {
          <li>{{ addLineItemCount }} line item(s) will be added</li>
        }
        @if (updateLineItemCount > 0) {
          <li>{{ updateLineItemCount }} line item(s) will be updated</li>
        }
        @if (removeLineItemCount > 0) {
          <li>{{ removeLineItemCount }} line item(s) will be deleted</li>
        }
      </ul>
      @if (acceptLineItems.length > 0) {
        {{ acceptLineItems.length }} line item(s) will be accepted for packing:
        <ng-container
          *ngTemplateOutlet="
            stateUpdates;
            context: { lineItems: acceptLineItems, usePlannedQty: true }
          "
        />
      }
      @if (wontPackLineItems.length > 0) {
        {{ wontPackLineItems.length }} line item(s) will be marked as "Won't
        Pack":
        <ng-container
          *ngTemplateOutlet="
            stateUpdates;
            context: { lineItems: wontPackLineItems, usePlannedQty: false }
          "
        />
      }
      @if (revertLineItems.length > 0) {
        {{ revertLineItems.length }} line item(s) will be reverted to "Created"
        state:
        <ng-container
          *ngTemplateOutlet="
            stateUpdates;
            context: { lineItems: revertLineItems, usePlannedQty: false }
          "
        />
      }
    }

    @if (action === "accept") {
      You are about to accept {{ selectedLineItems.length }} items:
    }
    @if (action === "wont pack") {
      You are about to mark {{ selectedLineItems.length }} items as won't pack:
    }
    @if (action !== "save order" && action !== "accept planning items") {
      <ng-container
        *ngTemplateOutlet="
          stateUpdates;
          context: { lineItems: selectedLineItems, usePlannedQty: true }
        "
      />
    }

    @if (action === "save order") {
      The following will happen when saved:
      <ul class="flex list-disc flex-col gap-1 pl-5">
        @if (lineItemGroupingMutations.add.length > 0) {
          <li>
            {{ lineItemGroupingMutations.add.length }} line items group(s) will
            be added
          </li>
        }
        @if (lineItemGroupingMutations.update.length > 0) {
          <li>
            {{ lineItemGroupingMutations.update.length }} line items group(s)
            will be updated
          </li>
        }
        @if (lineItemGroupingMutations.remove.length > 0) {
          <li>
            {{ lineItemGroupingMutations.remove.length }} line items group(s)
            will be deleted
          </li>
        }
        @if (addLineItemCount > 0) {
          <li>{{ addLineItemCount }} line item(s) will be added</li>
        }
        @if (updateLineItemCount > 0) {
          <li>{{ updateLineItemCount }} line item(s) will be updated</li>
        }
        @if (removeLineItemCount > 0) {
          <li>{{ removeLineItemCount }} line item(s) will be deleted</li>
        }
      </ul>
    }

    @if (action === "save order" && lineItemMutationKeys().length > 0) {
      <span style="cursor: pointer" (click)="toggleVerboseDetails()">
        @if (!showDetails) {
          <div>
            <small id="verboseToggle" class="flex items-center gap-1">
              <svg-icon src="/assets/icons/general/chevron-down.svg" />
              Show detailed changes
            </small>
          </div>
        }
        @if (showDetails) {
          <div>
            <small id="verboseToggle" class="flex items-center gap-1">
              <svg-icon src="/assets/icons/general/chevron-up.svg" />
              Hide detailed changes
            </small>
          </div>
        }
      </span>
    }
    @if (
      action === "save order" &&
      showDetails &&
      lineItemMutationKeys().length > 0
    ) {
      <ng-container>Line item fields to be updated:</ng-container>
      <ng-container
        *ngTemplateOutlet="
          verboseUpdates;
          context: { lineItemGroupings: lineItemMutationKeys() }
        "
      />
    }
  </div>

  <ng-template
    #stateUpdates
    let-lineItems="lineItems"
    let-usePlannedQty="usePlannedQty"
  >
    <ul class="flex list-disc flex-col gap-1 pl-5">
      @for (lineItem of lineItems; track lineItem) {
        <li>
          #{{
            lineItem["parentItemId"] > 0
              ? lineItem["parentItemId"] + " dup"
              : lineItem.id
          }}
          -
          {{
            lineItem.plannedQuantity && usePlannedQty
              ? lineItem.plannedQuantity
              : lineItem.quantity
          }}
          {{ lineItem.quantityUnit }}s of
          {{ lineItem.variety.commodity.name }} going to
          {{ lineItem.targetRegion }}
          {{
            lineItem.sellerId !== lineItem.newSellerId &&
            (lineItem.hasOwnProperty("sellerId") || lineItem.newSellerId) &&
            tradePartners
              ? "allocated to " + allocationCompany(lineItem)
              : ""
          }}
        </li>
      }
    </ul>
  </ng-template>

  <ng-template #verboseUpdates let-lineItemGroupings="lineItemGroupings">
    <ul class="flex list-disc flex-col gap-1 pl-5">
      @for (grp of lineItemGroupings; track grp) {
        <li>
          Line item grouping #{{ grp }}:
          <ul class="flex list-disc flex-col gap-1 pl-5">
            @for (li of lineItemMutations[grp].update; track li) {
              <li>
                @if (li["changedFields"]) {
                  LI #{{ li.id }} -
                  @for (
                    field of li["changedFields"] | keyvalue;
                    track field;
                    let lastField = $last
                  ) {
                    {{ field.key }}:
                    {{ field.key === "Additional Fields" ? "" : field.value }}
                    @if (field.key === "Additional Fields") {
                      {{ "{" }}
                      @for (
                        field of li.additionalFields["changedFields"]
                          | keyvalue;
                        track field;
                        let lastField = $last
                      ) {
                        {{ field.key }}: {{ field.value
                        }}{{ lastField ? "" : "," }}
                      }
                      {{ "}" }}
                    }
                    {{ lastField ? "" : "," }}
                  }
                }
                @if (!li["changedFields"]) {
                  <!-- hack to rather display 'N/A' in weird edge cases than just
                  leaving a blank bullet point -->
                  N/A
                }
              </li>
            }
          </ul>
        </li>
      }
    </ul>
  </ng-template>
</ag-modal-base>
